/** Strip a wrapping ```markdown code fence that the LLM sometimes adds around
 * an otherwise complete markdown answer (DAI-1290). ReactMarkdown renders such
 * a message as a code block, so the user sees raw "###"/"**" characters instead
 * of formatted text. Only "markdown"/"md"-tagged fences are unwrapped; real
 * code snippets (```python etc.) are left intact. Returns the original text
 * when there is no outer fence. */
export function unwrapMarkdownFence(text: string): string {
	const trimmed = text.trim();
	if (!trimmed.startsWith("```") || !trimmed.endsWith("```")) return text;
	const firstNewline = trimmed.indexOf("\n");
	if (firstNewline === -1) return text;
	const lang = trimmed.slice(3, firstNewline).trim().toLowerCase();
	if (lang !== "markdown" && lang !== "md") return text;
	const inner = trimmed.slice(firstNewline + 1, -3);
	return inner.trim();
}
